// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Receita_BreakdownResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /dashboards/receita/breakdown?dim={forma_pagamento|provedor|operador}
 *
 * Per-dimension breakdown of recebimentos in the filter window.
 *
 * `dim` echoes the requested dimension for FE consumers that switch
 * tabs without re-issuing a parameterized query. `items` is sorted
 * by `recebido_bruto` DESC; ties broken by `label` ASC.
 */
import type { Receita_BreakdownRow } from './Receita_BreakdownRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Receita_BreakdownResponseDados {
dim: string
items: Receita_BreakdownRow[]
}

export type Receita_BreakdownResponse = ApiResponse<Receita_BreakdownResponseDados>;

registerResponseContract('Receita_BreakdownResponse', {
  dim:   { type: 'string',  required: true },
  items: {
    type: 'array',
    required: true,
    items: {
      key:                { type: 'string',  required: false },
      label:              { type: 'string',  required: false },
      recebido_bruto:     { type: 'number',  required: false },
      recebido_liquido:   { type: 'number',  required: false },
      count_recebimentos: { type: 'number',  required: false },
    },
  },
})
